import History from './History.vue';

export default History;



// WEBPACK FOOTER //
// ./src/pages/profile/views/history/index.ts